import { actionCreator } from '@ardoq/rxbeach';
import { type ArdoqId } from '@ardoq/api-types';
import { type Entry, type EntryValue } from './types';
import { type ResolvedReverseReference } from './reverseReferences';

export type ReverseReferencesModalOpenedPayload = {
  entries: Entry[];
  unsafeResolvedById: Record<ArdoqId, ResolvedReverseReference>;
};

export type ReverseReferenceEntryChangedPayload = {
  index: number;
  typeValue: number | null;
};

export type ReverseReferencesModalConfirmedPayload = {
  entryValues: EntryValue[];
  unsafeResolvedById: Record<ArdoqId, ResolvedReverseReference>;
};

export const reverseReferencesModalOpened =
  actionCreator<ReverseReferencesModalOpenedPayload>(
    '[reverse references modal] REVERSE_REFERENCES_MODAL_OPENED'
  );

export const reverseReferencesModalClosed = actionCreator(
  '[reverse references modal] REVERSE_REFERENCES_MODAL_CLOSED'
);

export const reverseReferenceEntryChanged =
  actionCreator<ReverseReferenceEntryChangedPayload>(
    '[reverse references modal] REVERSE_REFERENCE_ENTRY_CHANGED'
  );

export const allReverseReferenceEntriesChanged = actionCreator<string>(
  '[reverse references modal] ALL_REVERSE_REFERENCE_ENTRIES_CHANGED'
);

export const reverseReferencesModalConfirmed =
  actionCreator<ReverseReferencesModalConfirmedPayload>(
    '[reverse references modal] REVERSE_REFERENCES_MODAL_CONFIRMED'
  );
